import HotelCard from './HotelCard.component';
export default HotelCard;